<script lang="ts">
	//Services
	import { postReq } from '../../../../services/http';
	import { format } from 'svelte-i18n';
	import { onMount } from 'svelte';
	//Stores
	import { user_data, user_settings } from 'src/stores/account/user';
import { alarms, temp_schemes } from 'src/stores/lists/scenes-derived';
	//Helpers
	import { time_zones, current_time_zone } from '../../../../helpers/date_helper';
	import { savePowerPricesByTimeZone } from '../../../../helpers/power_prices_helpers';
	import CacheStatisticRequest from 'src/components/Chart/chart_cache_helper';
	//Design system components
	import { Alert, Button, Col, Row, Select, toast } from '@Shelly/shelly-design-system';
	import type { SelectOptionType } from '@Shelly/shelly-design-system';
	import { transformedTimeZones } from 'src/helpers/utilities';
	import { scenes } from 'src/stores/lists/scenes';

	let timeZone: SelectOptionType = $user_data.timezone;
	let timeZones = transformedTimeZones(time_zones);

	function LocalZone() {
		timeZone =
			timeZones.find((el) => el.stringToSend === current_time_zone())?.stringToVisualise ||
			timeZone;
	}

	onMount(() => {
		timeZone = timeZones?.find((el) => el.stringToSend === timeZone)?.stringToVisualise || timeZone;
	});

	export const handleChangeTimeZone = async (timezone) => {
		timezone = timeZones.find((el) => el.stringToVisualise === timeZone).stringToSend;

		let res = await postReq('/user/set_timezone', { timezone });

		if (res.isok) {
			user_data.update({ timezone });
			user_settings.update((current_params) => {
				return { ...current_params, timezone };
			});
			savePowerPricesByTimeZone();
			CacheStatisticRequest.clear();
			return toast.open({
				type: 'success',
				title: $format('setting_scc_saved_toast'),
			});
		} else {
			return toast.open({
				type: 'danger',
				title: $format('setting_err_toast'),
			});
		}
	};
	//ToDo need to add search maybe
</script>

{#if Object.keys($scenes).filter((sceneKey) => ![...Object.keys($temp_schemes), ...Object.keys($alarms)].includes(sceneKey) && $scenes?.[sceneKey]?._run_on_ingest).length > 0}
	<Alert
		class="mb-s"
		heading={$format('alert_info_timezone_change', {
			default:
				'If you have enabled scenes with the "Run scene on save" option activated, keep in mind that they are likely to be triggered when the time zone changes, since such scenes are generally intended to define a default state.',
		})}
	/>
{/if}

<Row>
	<Col xs="12" md="3">
		<Select
			aria-label={$format('select_timezone', { default: 'Select timezone' })}
			value={timeZone}
			isAutocomplete
			icon="fas fa-globe"
			options={timeZones.map((tz) => tz.stringToVisualise)}
			on:change={(e) => (timeZone = e.detail)}
			id="select-za8nvar"
		/>
	</Col>
	<Col>
		<div class="d-flex flex-wrap">
			<Button
				class="mr-md-s mr-sm-0 mb-s mb-md-0 width-md-auto width-sm-full"
				size="m"
				on:click={() => handleChangeTimeZone(timeZone)}
			>
				{$format('button_save')}
			</Button>

			<Button
				class="width-md-auto width-sm-full"
				size="m"
				variant="secondary"
				on:click={LocalZone}
			>
				{$format('button_detect_timezone') || 'Detect Timezone'}
			</Button>
		</div>
	</Col>
</Row>
